import { getPresets } from '../../../api';
import { errorCannotLoadData } from '../../../store/error/actions';
import { loadingNextStage } from '../../../store/loading/actions';
import { presetsSet } from '../../../store/presets/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const loadPresets = async () => {
  const response = await getPresets();

  const presets = response.data;

  for (let key in presets) {
    presets[key] = {
      ...presets[key],
      editable: key.indexOf('preset') >= 0,
    };
  }

  return presets;
};

const useLoadPresets = (canLoadData) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const getPresetsAsync = async () => {
      try {
        const presets = await loadPresets();

        dispatch(presetsSet(presets));
        dispatch(loadingNextStage());
      } catch {
        dispatch(errorCannotLoadData());
      }
    };

    if (canLoadData) {
      getPresetsAsync();
    }
  }, [dispatch, canLoadData]);
};

export default useLoadPresets;
